"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _checkbox = _interopRequireDefault(require("../checkbox"));
var _configProvider = require("../config-provider");
var _divider = _interopRequireDefault(require("../divider"));
var _select = _interopRequireDefault(require("../select"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var InternalSelectRichDropdown = function InternalSelectRichDropdown(props, ref) {
  var title = props.title,
    options = props.options,
    value = props.value,
    defaultValue = props.defaultValue,
    customizePrefixCls = props.prefixCls,
    _props$optionLabelIco = props.optionLabelIconOnly,
    optionLabelIconOnly = _props$optionLabelIco === void 0 ? false : _props$optionLabelIco,
    optionLabelIcon = props.optionLabelIcon,
    className = props.className,
    popupClassName = props.popupClassName,
    restProps = __rest(props, ["title", "options", "value", "defaultValue", "prefixCls", "optionLabelIconOnly", "optionLabelIcon", "className", "popupClassName"]);
  var _React$useContext = _react["default"].useContext(_configProvider.ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls('select', customizePrefixCls);
  var _useState = (0, _react.useState)(value || defaultValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  (0, _react.useEffect)(function () {
    if (value) {
      setInnerValue(value);
    }
  }, [value]);
  var handleChange = function handleChange(val, option) {
    setInnerValue(val);
    if (props.onChange) {
      props.onChange(val, option);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_select["default"], (0, _extends2["default"])({
    ref: ref,
    defaultValue: defaultValue,
    value: innerValue,
    onChange: handleChange,
    className: (0, _classnames["default"])("".concat(prefixCls, "-rich-dropdown"), className),
    popupClassName: (0, _classnames["default"])("".concat(prefixCls, "-rich-dropdown-popup"), popupClassName),
    dropdownMatchSelectWidth: false,
    showArrow: false,
    optionLabelProp: optionLabelIconOnly ? '__labelIcon' : 'label',
    dropdownRender: function dropdownRender(menu) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, title && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
        className: "".concat(prefixCls, "-rich-dropdown-title")
      }, title), /*#__PURE__*/_react["default"].createElement(_divider["default"], {
        style: {
          margin: '2px 0'
        }
      })), menu);
    }
  }, restProps), options === null || options === void 0 ? void 0 : options.map(function (item) {
    var isSelected = false;
    if (innerValue && item.value) {
      if (typeof innerValue === 'number') {
        isSelected = String(innerValue).includes(String(item.value));
      } else {
        isSelected = innerValue === null || innerValue === void 0 ? void 0 : innerValue.includes(String(item.value));
      }
    }
    return /*#__PURE__*/_react["default"].createElement(_select["default"].Option, {
      key: item.value,
      value: item.value,
      label: item.label,
      __labelIcon: optionLabelIcon || item.label
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])("".concat(prefixCls, "-rich-dropdown-item-option"))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])("".concat(prefixCls, "-rich-dropdown-item-option-inner"))
    }, /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
      checked: isSelected
    }), item.label), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])("".concat(prefixCls, "-rich-dropdown-item-option-extra"))
    }, item.extra)));
  }));
};
var SelectRichDropdown = /*#__PURE__*/_react["default"].forwardRef(InternalSelectRichDropdown);
if (process.env.NODE_ENV !== 'production') {
  SelectRichDropdown.displayName = 'SelectDropdown';
}
var _default = exports["default"] = SelectRichDropdown;